import React, { useState } from 'react';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import Notification from 'antd/lib/notification';
import { ReplicateFurnitureIcon } from 'icons';
import { getCore } from 'cvat-core-wrapper';
import CVATTooltip from 'components/common/cvat-tooltip';
import { fetchAnnotationsAsync, saveAnnotationsAsync } from '../../../../actions/annotation-actions';
import { getCVATStore } from '../../../../cvat-store';

export interface Props {
    jobId: number;
}

function UnitReplicateControl(props: Props): JSX.Element {
    const { jobId } = props;
    const [running, setRunning] = useState(false);
    const storage = getCVATStore();
    const core = getCore();

    const replicate = async (): Promise<void> => {
        setRunning(true);
        await storage.dispatch(
            saveAnnotationsAsync(async () => {
                try {
                    const response = await core.server.request(
                        `${core.config.backendAPI}/jobs/${jobId}/units/replicate`,
                        { method: 'POST' },
                    );
                    const { created, units } = response.data;
                    Notification.info({
                        message: `Replicated ${created} furniture shapes`,
                        description: units.map((u: any) => `${u.unit} vs ${u.reference}: ` +
                            `${Object.entries(u.missing).map(([k, v]: [string, any]) => `${k} ${v[0]}/${v[1]}`).join(', ')}` +
                            `${Object.entries(u.extra).map(([k, v]: [string, any]) => ` ${k} ${v[0]}/${v[1]} (extra)`).join('')}`)
                            .join('\n') || 'All units of each type match their reference',
                    });
                    await storage.dispatch(fetchAnnotationsAsync(true));
                } catch (error: any) {
                    Notification.error({ message: 'Replicate units failed', description: error.toString() });
                } finally {
                    setRunning(false);
                }
            }),
        );
    };

    return (
        <CVATTooltip title='Copy the reference unit furniture into the other units of its type' placement='right'>
            {running ? (
                <LoadingOutlined className='cvat-opencv-control' />
            ) : (
                <Icon className='cvat-opencv-control' component={ReplicateFurnitureIcon} onClick={replicate} />
            )}
        </CVATTooltip>
    );
}

export default React.memo(UnitReplicateControl);
